// import React, { useState } from "react";
// import Typography from "@mui/material/Typography";
// import { Box, Button, Card, CardContent, Collapse, Grid } from "@mui/material";
// // React Icons (Font Awesome set)
// import {
//   FaClock,
//   FaBell,
//   FaTachometerAlt,
//   FaChartBar,
//   FaCogs,
//   FaSlidersH,
// } from "react-icons/fa";
// // React Icons for Stats Section
// import { FaHistory, FaBuilding, FaCalendarCheck } from "react-icons/fa";
// import FeatureSection from "./FeatureSection";
// import { motion } from "framer-motion";

// // Inline CSS for Homepage to ensure icon colors
// const styles = `
//   .feature-icon {
//     font-size: 64px !important;
//     transition: color 0.3s ease, fill 0.3s ease !important;
//   }
//   .feature-icon.hovered {
//     color: #006A71 !important;
//     fill: #006A71 !important;
//   }
//   .feature-icon:not(.hovered) {
//     color: #033538 !important;
//     fill: #033538 !important;
//   }
// `;

// const Homepage = () => {
//   const [hoveredCard, setHoveredCard] = useState(null);

//   const features = [
//     {
//       icon: "🧭",
//       title: "Clarity Over Complexity",
//       details:
//         "Minimal learning curve. Designed to make interview management feel effortless.",
//     },
//     {
//       icon: "🛠️",
//       title: "Role-Based Dashboards",
//       details:
//         "Tailored interfaces for HR, Interviewers, and Admins with relevant tools at their fingertips.",
//     },
//     {
//       icon: "📈",
//       title: "Real-Time Progress & Analytics",
//       details:
//         "Track every candidate's journey and panel performance in one elegant view.",
//     },
//     {
//       icon: "🧾",
//       title: "Structured Feedback Made Easy",
//       details:
//         "Simple templates and reminders ensure timely, useful input from every round.",
//     },
//     {
//       icon: "🔄",
//       title: "Smooth Scheduling Workflow",
//       details:
//         "Integrated with calendars and notifications—no more back-and-forths.",
//     },
//     {
//       icon: <FaSlidersH />,
//       title: "Custom Workflows",
//       details:
//         "Configure workflows for screening, scoring, and follow-ups to match your hiring policies.",
//     },
//   ];

//   // Testimonials Data
//   const testimonials = [
//     {
//       quote:
//         "Strategic Hire transformed our hiring process! The scheduling is seamless, and the insights are spot-on.",
//       author: "Sarah Johnson",
//       company: "TechCorp",
//     },
//     {
//       quote:
//         "The mobile dashboard saved us hours of work. Highly recommend this tool!",
//       author: "Michael Lee",
//       company: "Innovate Solutions",
//     },
//     {
//       quote:
//         "Custom workflows and integrations have made our recruitment smarter and faster.",
//       author: "Emily Davis",
//       company: "Global Enterprises",
//     },
//   ];

//   // Pricing Data
//   const pricingPlans = [
//     {
//       title: "Starter",
//       price: "$99/mo",
//       features: ["50 interviews/mo", "Basic AI analytics", "Email support"],
//     },
//     {
//       title: "Pro",
//       price: "$299/mo",
//       features: [
//         "200 interviews/mo",
//         "Advanced AI insights",
//         "Priority support",
//       ],
//     },
//     {
//       title: "Enterprise",
//       price: "Custom",
//       features: ["Unlimited interviews", "Full AI suite", "Dedicated support"],
//     },
//   ];

//   return (
//     <div style={{ backgroundColor: "white", minHeight: "100vh" }}>
//       {/* Inline CSS */}
//       <style>{styles}</style>
//       {/* Hero Section */}
//       <Box
//         sx={{
//           py: 8,
//           background: "linear-gradient(135deg, #004d4d, #002626)",
//           overflow: "hidden",
//           height: "100%",
//           display: "flex",
//           justifyContent: "center",
//         }}
//       >
//         <Grid
//           container
//           spacing={6} // Increased spacing between grid items
//           sx={{
//             maxWidth: "1200px",
//             width: "100%",
//             mx: "auto",

//             alignItems: "center",
//           }}
//         >
//           {/* Left Side - Image */}
//           <Grid
//             item
//             xs={12}
//             md={5}
//             sx={{ display: "flex", justifyContent: "center" }}
//           >
//             <motion.div
//               initial={{ opacity: 0, x: -100 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ duration: 1 }}
//             >
//               <Box
//                 component="img"
//                 src="/assests/images/heroimage.png"
//                 alt="Strategic Hiring"
//                 sx={{
//                   width: "100%",
//                   maxWidth: "650px",
//                   borderRadius: "12px",
//                   boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
//                 }}
//               />
//             </motion.div>
//           </Grid>

//           {/* Right Side - Text Content */}
//           <Grid
//             item
//             xs={12}
//             md={7}
//             sx={{
//               textAlign: { xs: "center", md: "left" },
//               pl: { md: 3 }, // Add extra padding on the left side of text content
//             }}
//           >
//             <Box
//               sx={{
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: 3,
//               }}
//             >
//               {/* Animated Title */}
//               <motion.div
//                 initial={{ opacity: 0, x: -100 }}
//                 animate={{ opacity: 1, x: 0 }}
//                 transition={{ duration: 0.8, ease: "easeOut" }}
//               >
//                 <Typography
//                   variant="h3"
//                   color="#e0f7fa"
//                   sx={{
//                     fontWeight: "900",
//                     lineHeight: 1.1,
//                     wordBreak: "break-word",
//                   }}
//                 >
//                   Revolutionize Hiring with Strategic Precision
//                 </Typography>
//               </motion.div>

//               {/* Animated Subtitle */}
//               <motion.div
//                 initial={{ opacity: 0, x: 100 }}
//                 animate={{ opacity: 1, x: 0 }}
//                 transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
//               >
//                 <Typography
//                   variant="h5"
//                   color="#b2dfdb"
//                   sx={{
//                     lineHeight: 1.4,
//                     wordBreak: "break-word",
//                   }}
//                 >
//                   Empower your team with seamless recruitment — from talent
//                   search to onboarding success.
//                 </Typography>
//               </motion.div>

//               {/* Button */}
//               <motion.div
//                 initial={{ opacity: 0, scale: 0.8 }}
//                 animate={{
//                   opacity: 1,
//                   scale: [1, 1.05, 1],
//                   transition: {
//                     opacity: { duration: 0.5 },
//                     scale: { duration: 1.5, repeat: Infinity },
//                   },
//                 }}
//                 whileHover={{ scale: 1.05 }}
//                 whileTap={{ scale: 0.9 }}
//                 sx={{
//                   display: "flex",
//                   justifyContent: { xs: "center", md: "flex-start" },
//                 }}
//               >
//                 <Button
//                   sx={{
//                     backgroundColor: "white",
//                     color: "#004d4d",
//                     py: 2,
//                     px: 4,
//                     "&:hover": { backgroundColor: "#b2dfdb", color: "#004d4d" },
//                     borderRadius: 10,
//                     fontSize: "16px",
//                     fontWeight: "bold",
//                   }}
//                 >
//                   Start Your Hiring Revolution
//                 </Button>
//               </motion.div>
//             </Box>
//           </Grid>
//         </Grid>
//       </Box>
//       <FeatureSection />
//       {/* Stats Section */}
//       <Box
//         sx={{
//           backgroundColor: "#006A71",
//           color: "white",
//           display: "flex",
//           justifyContent: "space-evenly",
//           p: 3,
//         }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//           }}
//         >
//           <FaHistory style={{ fontSize: 80, color: "white" }} />
//           <Typography>5+ years of experience</Typography>
//         </Box>
//         <Box
//           sx={{
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//           }}
//         >
//           <FaBuilding style={{ fontSize: 80, color: "white" }} />
//           <Typography>200+ Companies</Typography>
//         </Box>
//         <Box
//           sx={{
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//           }}
//         >
//           <FaCalendarCheck style={{ fontSize: 80, color: "white" }} />
//           <Typography>10K+ Interviews Processed</Typography>
//         </Box>
//       </Box>
//       {/* Features Section */}
//       <Box sx={{ py: 5 }}>
//         <Typography
//           variant="h5"
//           color="#006A71"
//           sx={{ textAlign: "center", p: 3, fontWeight: "bold" }}
//         >
//           What Strategic Hire Offers Enterprises
//         </Typography>
//         <Grid container spacing={3} sx={{ px: 8 }}>
//           {features.map((feature, index) => (
//             <Grid item xs={12} sm={6} md={4} key={index}>
//               <Card
//                 sx={{
//                   display: "flex",
//                   flexDirection: "column",
//                   "&:hover": {
//                     transform: "translateY(-5px)",
//                     transition: "all 0.3s ease",
//                   },
//                   textAlign: "center",
//                   position: "relative",
//                   backgroundColor: "#eef0eb",
//                 }}
//                 onMouseEnter={() => setHoveredCard(index)}
//                 onMouseLeave={() => setHoveredCard(null)}
//               >
//                 <CardContent
//                   sx={{
//                     flexGrow: 1,
//                     display: "flex",
//                     flexDirection: "column",
//                     alignItems: "center",
//                     py: 5,
//                   }}
//                 >
//                   <Box sx={{ mb: 2 }}>
//                     <span
//                       role="img"
//                       aria-label="compass"
//                       className={`feature-icon ${
//                         hoveredCard === index ? "hovered" : ""
//                       }`}
//                       style={{
//                         fontSize: 64,
//                         transition: "color 0.3s ease, fill 0.3s ease",
//                         color: hoveredCard === index ? "#7209b7" : "#000000",
//                       }}
//                     >
//                       {feature.icon}
//                     </span>
//                   </Box>

//                   <Typography
//                     variant="h5"
//                     component="h2"
//                     gutterBottom
//                     sx={{ fontWeight: "bold", color: "#006A71" }}
//                   >
//                     {feature.title}
//                   </Typography>
//                   {/* <Typography variant="body1" color="#033538">
//                     {feature.description}
//                   </Typography> */}
//                   <Collapse
//                     in={hoveredCard === index}
//                     timeout="auto"
//                     unmountOnExit
//                     sx={{ width: "100%", mt: 2 }}
//                   >
//                     <Box
//                       sx={{ backgroundColor: "#f5f5f5", p: 2, borderRadius: 1 }}
//                     >
//                       <Typography variant="body2" color="text.secondary">
//                         {feature.details}
//                       </Typography>
//                     </Box>
//                   </Collapse>
//                 </CardContent>
//               </Card>
//             </Grid>
//           ))}
//         </Grid>
//       </Box>

//       <Box sx={{ py: 5, backgroundColor: "#9ACBD0" }}>
//         <Typography
//           variant="h4"
//           color="#006A71"
//           sx={{ textAlign: "center", p: 3, fontWeight: "bold" }}
//         >
//           What Our Clients Say
//         </Typography>
//         <Grid container spacing={3} sx={{ px: 8 }}>
//           {testimonials.map((testimonial, index) => (
//             <Grid item xs={12} sm={4} key={index}>
//               <Card
//                 sx={{
//                   textAlign: "center",
//                   p: 2,
//                   height: "100%", // Make all cards take full height of the grid item
//                   display: "flex",
//                   flexDirection: "column",
//                   "&:hover": {
//                     transform: "translateY(-5px)",
//                     transition: "all 0.3s ease",
//                   },
//                 }}
//               >
//                 <CardContent
//                   sx={{
//                     flexGrow: 1,
//                     display: "flex",
//                     flexDirection: "column",
//                     justifyContent: "space-between",
//                   }}
//                 >
//                   <Typography variant="body1" color="#033538" sx={{ mb: 2 }}>
//                     "{testimonial.quote}"
//                   </Typography>
//                   <Typography
//                     variant="subtitle1"
//                     sx={{ fontWeight: "bold", color: "#48A6A7" }}
//                   >
//                     {testimonial.author}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     {testimonial.company}
//                   </Typography>
//                 </CardContent>
//               </Card>
//             </Grid>
//           ))}
//         </Grid>
//       </Box>

//       <Box sx={{ py: 5 }}>
//         <Typography
//           variant="h5"
//           color="#006A71"
//           sx={{ textAlign: "center", p: 3, fontWeight: "bold" }}
//         >
//           Pricing Plans
//         </Typography>
//         <Grid container spacing={3} sx={{ px: 8 }}>
//           {pricingPlans.map((plan, index) => (
//             <Grid item xs={12} sm={4} key={index}>
//               <Card
//                 sx={{
//                   textAlign: "center",
//                   "&:hover": {
//                     transform: "translateY(-5px)",
//                     transition: "all 0.3s ease",
//                   },
//                 }}
//               >
//                 <CardContent>
//                   <Typography
//                     variant="h6"
//                     sx={{ fontWeight: "bold", color: "#006A71" }}
//                   >
//                     {plan.title}
//                   </Typography>
//                   <Typography variant="h4" color="#033538" sx={{ my: 2 }}>
//                     {plan.price}
//                   </Typography>
//                   {plan.features.map((feature, i) => (
//                     <Typography key={i} variant="body2" color="text.secondary">
//                       {feature}
//                     </Typography>
//                   ))}
//                   <Button
//                     sx={{
//                       mt: 2,
//                       backgroundColor: "#006A71",
//                       color: "white",
//                       "&:hover": { backgroundColor: "#033538" },
//                     }}
//                   >
//                     Choose Plan
//                   </Button>
//                 </CardContent>
//               </Card>
//             </Grid>
//           ))}
//         </Grid>
//       </Box>
//     </div>
//   );
// };

// export default Homepage;







import React, { useState } from "react";
import { Box, Container } from "@mui/material";
import { FaRocket, FaShieldAlt, FaBolt, FaHeartbeat } from 'react-icons/fa';
import "../assets/css/main.css";
import img1 from "../assets/images/img1.jpg"
import img2 from "../assets/images/img2.jpg"
import img3 from "../assets/images/img3.jpg"
import innovation from "../assets/images/innovation.jpg"
import security from "../assets/images/security.jpg"
import performance from "../assets/images/performance.jpg"
import support from "../assets/images/support1.jpg"
import person1 from "../assets/images/person1.webp"
import person2 from "../assets/images/person2.webp"
import person3 from "../assets/images/person3.webp"
import person4 from "../assets/images/person4.webp"
import person5 from "../assets/images/person5.webp"
import avatar1 from "../assets/images/avatar1.webp"
import avatar2 from "../assets/images/avatar2.webp"
import avatar3 from "../assets/images/avatar3.webp"
import avatar4 from "../assets/images/avatar5.webp"
import useHeaderScroll from "../hooks/useHeaderScroll";
import useMobileNav from "../hooks/useMobileNav";
import useTypedText from "../hooks/useTypedText";
import useAOSInit from "../hooks/useAOSInit";
import usePureCounter from "../hooks/usePureCounter";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";



export default function Homepage() {
  useHeaderScroll();
  useMobileNav();
  useTypedText();
  useAOSInit();
  usePureCounter();


  const [activeTab, setActiveTab] = useState("tab-1");

  const isActive = (tab) => (activeTab === tab ? "active show" : "");

  return (
    <>
      <main className="main">

        {/* ================================================================================== HERO ========================================================================================= */}
        <section id="hero" className="hero section">
          <Container>
            <div className="hero-wrapper">
              <div className="hero-main-content text-center">
                <h1 className="hero-title" data-aos="zoom-in" data-aos-delay="200">
                  Hire Smarter. Faster. Fairer. With <br />
                  <span
                    className="typed"
                    data-typed-items="Advanced Analytics,Seamless Integration,Robust Security"
                  ></span>
                </h1>

                <p className="hero-description" data-aos="fade-up" data-aos-delay="300">
                  Strategic Hire is an AI-powered hiring platform that streamlines the entire interview lifecycle — from screening to final decision.
                </p>

                <div className="hero-actions" data-aos="fade-up" data-aos-delay="400">
                  <a href="#" className="action-btn primary">
                    <span>Start Free Trial</span>
                    <i className="bi bi-arrow-right"></i>
                  </a>
                  <a href="#" className="action-btn secondary">
                    <i className="bi bi-play-circle"></i>
                    <span>Watch a Quick Demo</span>
                  </a>
                </div>

                <div className="hero-image-showcase" data-aos="fade-up" data-aos-delay="500">
                  <div className="image-wrapper">
                    <img
                      src={img1}
                      className="img-fluid"
                      alt="Strategic Overview"
                    />

                    <div className="floating-card card-1">
                      <div className="card-content">
                        <div className="card-icon">
                          <i className="bi bi-bar-chart-line"></i>
                        </div>
                        <div className="card-info">
                          <h4>89%</h4>
                          <p>Success Benchmark</p>
                        </div>
                      </div>
                    </div>

                    <div className="floating-card card-2">
                      <div className="card-content">
                        <div className="card-icon">
                          <i className="bi bi-people"></i>
                        </div>
                        <div className="card-info">
                          <h4>500+</h4>
                          <p>Satisfied Clients</p>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </Container>
        </section>


      {/* ================================================================= ABOUT ================================================================================== */}

<section id="about" class="about section">

      <div class="container" data-aos="fade-up" data-aos-delay="100">

        <div class="row align-items-center justify-content-between g-lg-5">
          <div class="col-lg-6" data-aos="fade-right" data-aos-delay="200">
            <div class="image-wrapper">
              <img src={img2} class="img-fluid rounded" alt="About Us Image"/>
            </div>
          </div>

          <div class="col-lg-6" data-aos="fade-left" data-aos-delay="300">
            <div class="content">
              <h2 class="mb-4">Our Story</h2>
              <h5 class="mb-4">Crafting innovative solutions since 2010</h5>

              <p>Hiring is broken — slow processes, scattered tools, and biased decisions. Strategic Hire fixes this by bringing AI, structure, and transparency into one unified hiring platform.</p>

              <div class="features-list mt-5" data-aos="fade-up" data-aos-delay="400">
                <div class="row g-4">
                  <div class="col-md-6">
                    <div class="feature-item">
                      <i class="bi bi-award"></i>
                      <h5>Excellence</h5>
                      <p>AI‑driven resume screening.</p>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="feature-item">
                      <i class="bi bi-lightbulb"></i>
                      <h5>Innovation</h5>
                      <p>End‑to‑end interview lifecycle management.</p>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="feature-item">
                      <i class="bi bi-people"></i>
                      <h5>Community</h5>
                      <p>Structured, bias‑aware feedback.</p>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="feature-item">
                      <i class="bi bi-arrow-up-right"></i>
                      <h5>Growth</h5>
                      <p>Real‑time hiring analytics.</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mt-5" data-aos="fade-up" data-aos-delay="600">
                <a href="#" class="btn btn-primary me-3">Learn More</a>
                <a href="#" class="btn btn-outline-primary">Contact Us</a>
              </div>
            </div>
          </div>
        </div>

      </div>

    </section>


{/* ================================================================================== FEATURES ========================================================================================= */}


 <section id="features" class="features section">
    
      <div class="container section-title" data-aos="fade-up">
        <h2>Features</h2>
        <p>Everything you need to run modern, scalable hiring operations</p>
      </div>

      <div class="container" data-aos="fade-up" data-aos-delay="100">

        <div class="row align-items-center mb-5">
          <div class="col-lg-6" data-aos="fade-right" data-aos-delay="150">
            <div class="intro-content">
              <h2>Powerful features to accelerate growth</h2>
              <p>Automatically rank candidates based on skills, experience, and role fit.</p>
              <div class="feature-stats">
                <div class="stat-item">
                  <span class="stat-number">150+</span>
                  <span class="stat-label">Features</span>
                </div>
                <div class="stat-item">
                  <span class="stat-number">99.9%</span>
                  <span class="stat-label">Uptime</span>
                </div>
                <div class="stat-item">
                  <span class="stat-number">24/7</span>
                  <span class="stat-label">Support</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6" data-aos="fade-left" data-aos-delay="200">
            <div class="intro-image">
              <img src={img3} alt="Features" class="img-fluid"/>
            </div>
          </div>
        </div>

        <div class="features-grid">
          <div class="feature-item" data-aos="flip-up" data-aos-delay="250">
            <div class="feature-number">01</div>
            <div class="feature-content">
              <div class="feature-icon">
                <i class="bi bi-lightning"></i>
              </div>
              <h4>Lightning Fast Performance</h4>
              <p>Automated scheduling across interview panels and time zones.</p>
              <div class="feature-tags">
                <span class="tag">Speed</span>
                <span class="tag">Optimization</span>
              </div>
            </div>
          </div>

          <div class="feature-item" data-aos="flip-up" data-aos-delay="300">
            <div class="feature-number">02</div>
            <div class="feature-content">
              <div class="feature-icon">
                <i class="bi bi-shield-check"></i>
              </div>
              <h4>Enterprise Security</h4>
              <p>Secure, compliant, and ready for enterprise‑scale hiring.</p>
              <div class="feature-tags">
                <span class="tag">Secure</span>
                <span class="tag">Protected</span>
              </div>
            </div>
          </div>

          <div class="feature-item" data-aos="flip-up" data-aos-delay="350">
            <div class="feature-number">03</div>
            <div class="feature-content">
              <div class="feature-icon">
                <i class="bi bi-people-fill"></i>
              </div>
              <h4>Hiring Analytics</h4>
              <p>Track time‑to‑hire, funnel drop‑offs, and recruiter efficiency.</p>
              <div class="feature-tags">
                <span class="tag">Teamwork</span>
                <span class="tag">Sync</span>
              </div>
            </div>
          </div>

          <div class="feature-item" data-aos="flip-up" data-aos-delay="400">
            <div class="feature-number">04</div>
            <div class="feature-content">
              <div class="feature-icon">
                <i class="bi bi-graph-up"></i>
              </div>
              <h4>Advanced Analytics</h4>
              <p>Consistent scorecards for fair, data‑driven decisions.</p>
              <div class="feature-tags">
                <span class="tag">Data</span>
                <span class="tag">Insights</span>
              </div>
            </div>
          </div>

          <div class="feature-item" data-aos="flip-up" data-aos-delay="450">
            <div class="feature-number">05</div>
            <div class="feature-content">
              <div class="feature-icon">
                <i class="bi bi-gear-fill"></i>
              </div>
              <h4>Smart Automation</h4>
              <p>Automatically rank candidates based on skills, experience, and role fit.</p>
              <div class="feature-tags">
                <span class="tag">AI</span>
                <span class="tag">Workflow</span>
              </div>
            </div>
          </div>

          <div class="feature-item" data-aos="flip-up" data-aos-delay="500">
            <div class="feature-number">06</div>
            <div class="feature-content">
              <div class="feature-icon">
                <i class="bi bi-cloud-arrow-up"></i>
              </div>
              <h4>Role‑Based Dashboards</h4>
              <p>Tailored views for recruiters, interviewers, and managers.</p>
              <div class="feature-tags">
                <span class="tag">Cloud</span>
                <span class="tag">Scalable</span>
              </div>
            </div>
          </div>
        </div>

      </div>

    </section>


{/* ================================================================================== Features Tabs Section  ========================================================================================= */}

    <section id="features-tabs section" class="features-tabs">

      <div class="container" data-aos="fade-up" data-aos-delay="100">

        <div class="tabs-wrapper">
          <ul class="nav nav-tabs" data-aos="fade-up" data-aos-delay="100">

            <li class="nav-item">
              <a class="nav-link active show" data-bs-toggle="tab" data-bs-target="#features-tabs-tab-1">
                <div className="tab-icon">
                  {/* <i className="bi bi-rocket-takeoff-fill"></i> */}
                  <FaRocket style={{ color: 'black', fontSize: '20px' }}/>

                </div>
                <div class="tab-content">
                  <h5>Innovation</h5>
                  <span>Cutting-edge solutions</span>
                </div>
              </a>
            </li>

            <li class="nav-item">
              <a class="nav-link" data-bs-toggle="tab" data-bs-target="#features-tabs-tab-2">
                <div class="tab-icon">
                  {/* <i class="bi bi-shield-shaded"></i> */}
                  <FaShieldAlt style={{ color: 'black', fontSize: '20px' }}/>

                </div>
                <div class="tab-content">
                  <h5>Security</h5>
                  <span>Advanced protection</span>
                </div>
              </a>
            </li>

            <li class="nav-item">
              <a class="nav-link" data-bs-toggle="tab" data-bs-target="#features-tabs-tab-3">
                <div class="tab-icon">
                  {/* <i class="bi bi-lightning-charge"></i> */}
                  <FaBolt style={{ color: 'black', fontSize: '20px' }}/>

                </div>
                <div class="tab-content">
                  <h5>Performance</h5>
                  <span>Lightning fast speed</span>
                </div>
              </a>
            </li>

            <li class="nav-item">
              <a class="nav-link" data-bs-toggle="tab" data-bs-target="#features-tabs-tab-4">
                <div class="tab-icon">
                  {/* <i class="bi bi-heart-pulse"></i> */}
                  <FaHeartbeat style={{ color: 'black', fontSize: '20px' }}/>

                </div>
                <div class="tab-content">
                  <h5>Support</h5>
                  <span>24/7 assistance</span>
                </div>
              </a>
            </li>

          </ul>

          <div class="tab-content" data-aos="fade-up" data-aos-delay="200">

            <div class="tab-pane fade active show" id="features-tabs-tab-1">
              <div class="row align-items-center">

                <div class="col-lg-5">
                  <div class="content-wrapper">
                    <div className="icon-badge">
{/* <i className="bi bi-rocket-takeoff-fill"></i> */}
<FaRocket />

                    </div>
                    <h3>Innovation Excellence</h3>
                    <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam eaque ipsa quae ab illo inventore veritatis.</p>

                    <div class="feature-grid">
                      <div class="feature-item">
                        <i class="bi bi-check-circle-fill"></i>
                        <span>Excepteur sint occaecat cupidatat non proident</span>
                      </div>
                      <div class="feature-item">
                        <i class="bi bi-check-circle-fill"></i>
                        <span>Sunt in culpa qui officia deserunt mollit anim</span>
                      </div>
                      <div class="feature-item">
                        <i class="bi bi-check-circle-fill"></i>
                        <span>At vero eos et accusamus et iusto odio</span>
                      </div>
                      <div class="feature-item">
                        <i class="bi bi-check-circle-fill"></i>
                        <span>Et harum quidem rerum facilis est et expedita</span>
                      </div>
                    </div>

                    <div class="stats-row">
                      <div class="stat-item">
                        <div class="stat-number">99%</div>
                        <div class="stat-label">Uptime</div>
                      </div>
                      <div class="stat-item">
                        <div class="stat-number">50K+</div>
                        <div class="stat-label">Users</div>
                      </div>
                      <div class="stat-item">
                        <div class="stat-number">24/7</div>
                        <div class="stat-label">Support</div>
                      </div>
                    </div>

                    <a href="#" class="btn-primary">Learn More <i class="bi bi-arrow-right"></i></a>
                  </div>
                </div>

                <div class="col-lg-7">
                  <div class="visual-content">
                    <div class="main-image">
                      <img src={innovation} alt="" class="img-fluid"/>
                      <div class="floating-card">
                        {/* <i className="bi bi-lightning-charge"></i> */}
                        <FaBolt />

                        <div class="card-content">
                          <span>Performance</span>
                          <strong>+85% Improvement</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div class="tab-pane fade" id="features-tabs-tab-2">
              <div class="row align-items-center">

                <div class="col-lg-5">
                  <div class="content-wrapper">
                    <div class="icon-badge">
                      {/* <i class="bi bi-shield-shaded"></i> */}
                      <FaShieldAlt />

                    </div>
                    <h3>Advanced Security</h3>
                    <p>Neque porro quisquam est qui dolorem ipsum quia dolor sit amet consectetur adipisci velit sed quia non numquam eius modi tempora incidunt ut labore.</p>

                    <div class="feature-grid">
                      <div class="feature-item">
                        <i class="bi bi-check-circle-fill"></i>
                        <span>Temporibus autem quibusdam et aut officiis</span>
                      </div>
                      <div class="feature-item">
                        <i class="bi bi-check-circle-fill"></i>
                        <span>Nam libero tempore cum soluta nobis</span>
                      </div>
                      <div class="feature-item">
                        <i class="bi bi-check-circle-fill"></i>
                        <span>Itaque earum rerum hic tenetur a sapiente</span>
                      </div>
                      <div class="feature-item">
                        <i class="bi bi-check-circle-fill"></i>
                        <span>Quis autem vel eum iure reprehenderit qui</span>
                      </div>
                    </div>

                    <div class="stats-row">
                      <div class="stat-item">
                        <div class="stat-number">256-bit</div>
                        <div class="stat-label">Encryption</div>
                      </div>
                      <div class="stat-item">
                        <div class="stat-number">ISO</div>
                        <div class="stat-label">Certified</div>
                      </div>
                      <div class="stat-item">
                        <div class="stat-number">GDPR</div>
                        <div class="stat-label">Compliant</div>
                      </div>
                    </div>

                    <a href="#" class="btn-primary">Learn More <i class="bi bi-arrow-right"></i></a>
                  </div>
                </div>

                <div class="col-lg-7">
                  <div class="visual-content">
                    <div class="main-image">
                      <img src={security} alt="" class="img-fluid"/>
                      <div class="floating-card">
                        <i class="bi bi-shield-check"></i>
                        <div class="card-content">
                          <span>Security</span>
                          <strong>Military Grade</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div class="tab-pane fade" id="features-tabs-tab-3">
              <div class="row align-items-center">

                <div class="col-lg-5">
                  <div class="content-wrapper">
                    <div class="icon-badge">
                      {/* <i class="bi bi-lightning-charge"></i> */}
                      <FaBolt />

                    </div>
                    <h3>Lightning Performance</h3>
                    <p>Ut enim ad minima veniam quis nostrum exercitationem ullam corporis suscipit laboriosam nisi ut aliquid ex ea commodi consequatur quis autem vel.</p>

                    <div class="feature-grid">
                      <div class="feature-item">
                        <i class="bi bi-check-circle-fill"></i>
                        <span>Duis aute irure dolor in reprehenderit in voluptate</span>
                      </div>
                      <div class="feature-item">
                        <i class="bi bi-check-circle-fill"></i>
                        <span>Excepteur sint occaecat cupidatat non proident</span>
                      </div>
                      <div class="feature-item">
                        <i class="bi bi-check-circle-fill"></i>
                        <span>Sunt in culpa qui officia deserunt mollit</span>
                      </div>
                      <div class="feature-item">
                        <i class="bi bi-check-circle-fill"></i>
                        <span>Sed ut perspiciatis unde omnis iste natus</span>
                      </div>
                    </div>

                    <div class="stats-row">
                      <div class="stat-item">
                        <div class="stat-number">0.5s</div>
                        <div class="stat-label">Load Time</div>
                      </div>
                      <div class="stat-item">
                        <div class="stat-number">100%</div>
                        <div class="stat-label">Optimized</div>
                      </div>
                      <div class="stat-item">
                        <div class="stat-number">CDN</div>
                        <div class="stat-label">Global</div>
                      </div>
                    </div>

                    <a href="#" class="btn-primary">Learn More <i class="bi bi-arrow-right"></i></a>
                  </div>
                </div>

                <div class="col-lg-7">
                  <div class="visual-content">
                    <div class="main-image">
                      <img src={performance} alt="" class="img-fluid"/>
                      <div class="floating-card">
                        <i class="bi bi-speedometer2"></i>
                        <div class="card-content">
                          <span>Speed</span>
                          <strong>Ultra Fast</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div class="tab-pane fade" id="features-tabs-tab-4">
              <div class="row align-items-center">

                <div class="col-lg-5">
                  <div class="content-wrapper">
                    <div class="icon-badge">
                      {/* <i class="bi bi-heart-pulse"></i> */}
                      <FaHeartbeat />

                    </div>
                    <h3>Premium Support</h3>
                    <p>Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.</p>

                    <div class="feature-grid">
                      <div class="feature-item">
                        <i class="bi bi-check-circle-fill"></i>
                        <span>Neque porro quisquam est qui dolorem ipsum</span>
                      </div>
                      <div class="feature-item">
                        <i class="bi bi-check-circle-fill"></i>
                        <span>Quia dolor sit amet consectetur adipisci velit</span>
                      </div>
                      <div class="feature-item">
                        <i class="bi bi-check-circle-fill"></i>
                        <span>Sed quia non numquam eius modi tempora</span>
                      </div>
                      <div class="feature-item">
                        <i class="bi bi-check-circle-fill"></i>
                        <span>Incidunt ut labore et dolore magnam aliquam</span>
                      </div>
                    </div>

                    <div class="stats-row">
                      <div class="stat-item">
                        <div class="stat-number">24/7</div>
                        <div class="stat-label">Available</div>
                      </div>
                      <div class="stat-item">
                        <div class="stat-number">2min</div>
                        <div class="stat-label">Response</div>
                      </div>
                      <div class="stat-item">
                        <div class="stat-number">Expert</div>
                        <div class="stat-label">Team</div>
                      </div>
                    </div>

                    <a href="#" class="btn-primary">Learn More <i class="bi bi-arrow-right"></i></a>
                  </div>
                </div>

                <div class="col-lg-7">
                  <div class="visual-content">
                    <div class="main-image">
                      <img src={support} alt="" class="img-fluid"/>
                      <div class="floating-card">
                        <i class="bi bi-headset"></i>
                        <div class="card-content">
                          <span>Support</span>
                          <strong>Always Here</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>

      </div>

    </section>




{/* ================================================================================== Testimonials ========================================================================================= */}
 <section id="testimonials" class="testimonials section">

     
      <div class="container section-title" data-aos="fade-up">
        <h2>Testimonials</h2>
        <p>Trusted by fast‑growing hiring teams</p>
      </div>

      <div class="container" data-aos="fade-up" data-aos-delay="100">
          <Swiper
               modules={[Navigation, Autoplay]}
               loop
               speed={600}
               autoplay={{ delay: 4000 }}
               spaceBetween={30}
               navigation={{
                 nextEl: ".swiper-button-next",
                 prevEl: ".swiper-button-prev",
               }}
               breakpoints={{
                 0: { slidesPerView: 1 },
                 768: { slidesPerView: 2 },
                 1200: { slidesPerView: 3 },
               }}
               className="testimonial-slider"
             >
            
            <SwiperSlide>
              <div className="testimonial-item" data-aos="zoom-in" data-aos-delay="200">
                <div className="testimonial-header">
                  <img src={person1} alt="Client" className="img-fluid" loading="lazy"/>
                  <div className="rating">
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                  </div>
                </div>
                <div className="testimonial-body">
                  <p>Strategic Hire reduced our time‑to‑hire by nearly 50%. The AI screening is a game changer</p>
                </div>
                <div className="testimonial-footer">
                  <h5>Jessica Martinez</h5>
                  <span>Head of Talent Acquisition</span>
                  <div className="quote-icon">
                    <i className="bi bi-chat-quote-fill"></i>
                  </div>
                </div>
              </div>
            </SwiperSlide>

          
            <SwiperSlide >
              <div className="testimonial-item" data-aos="zoom-in" data-aos-delay="300">
                <div className="testimonial-header">
                  <img src={person4} alt="Client" className="img-fluid" loading="lazy"/>
                  <div className="rating">
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                  </div>
                </div>
                <div className="testimonial-body">
                  <p>We finally have visibility into our hiring pipeline. Everything is structured and measurable.</p>
                </div>
                <div className="testimonial-footer">
                  <h5>David Rodriguez</h5>
                  <span>People Ops Lead</span>
                  <div className="quote-icon">
                    <i className="bi bi-chat-quote-fill"></i>
                  </div>
                </div>
              </div>
            </SwiperSlide>

          
            <SwiperSlide >
              <div className="testimonial-item" data-aos="zoom-in" data-aos-delay="400">
                <div className="testimonial-header">
                  <img src={person3} alt="Client" className="img-fluid" loading="lazy"/>
                  <div className="rating">
                    <i className="bi bi-star-fill"></i>
                    <i classNameclassName="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                  </div>
                </div>
                <div className="testimonial-body">
                  <p> Recruiters save hours every week. Candidates love the smooth interview experience.</p>
                </div>
                <div className="testimonial-footer">
                  <h5>Amanda Wilson</h5>
                  <span>HR Director</span>
                  <div className="quote-icon">
                    <i className="bi bi-chat-quote-fill"></i>
                  </div>
                </div>
              </div>
            </SwiperSlide>

        
            <SwiperSlide >
              <div className="testimonial-item" data-aos="zoom-in" data-aos-delay="500">
                <div className="testimonial-header">
                  <img src={person2} alt="Client" className="img-fluid" loading="lazy"/>
                  <div className="rating">
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                  </div>
                </div>
                <div className="testimonial-body">
                  <p> Strategic Hire reduced our time‑to‑hire by nearly 50%. The AI screening is a game changer.</p>
                </div>
                <div className="testimonial-footer">
                  <h5>Ryan Thompson</h5>
                  <span>Talent Acquisition</span>
                  <div className="quote-icon">
                    <i className="bi bi-chat-quote-fill"></i>
                  </div>
                </div>
              </div>
            </SwiperSlide>

            
            <SwiperSlide>
              <div className="testimonial-item" data-aos="zoom-in" data-aos-delay="600">
                <div className="testimonial-header">
                  <img src={person5} alt="Client" className="img-fluid" loading="lazy"/>
                  <div className="rating">
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                  </div>
                </div>
                <div className="testimonial-body">
                  <p>We finally have visibility into our hiring pipeline. Everything is structured and measurable.</p>
                </div>
                <div className="testimonial-footer">
                  <h5>Ronaldo Chen</h5>
                  <span>Ops Lead Manager</span>
                  <div className="quote-icon">
                    <i className="bi bi-chat-quote-fill"></i>
                  </div>
                </div>
              </div>
            </SwiperSlide>
    </Swiper>
      </div>
    </section>


{/* ================================================================================== Stats Tab Section  ========================================================================================= */}

    <section id="stats" class="stats section light-background">

      {/* <div class="container" data-aos="fade-up" data-aos-delay="100"> */}

        <div class="row align-items-center">
          <div class="col-lg-4" data-aos="fade-up" data-aos-delay="200">
            <div class="avatars d-flex align-items-center">
              <img src={avatar1} alt="Avatar 1" class="rounded-circle" loading="lazy"/>
              <img src={avatar2} alt="Avatar 2" class="rounded-circle" loading="lazy"/>
              <img src={avatar3} alt="Avatar 3" class="rounded-circle" loading="lazy"/>
              <img src={avatar4} alt="Avatar 4" class="rounded-circle" loading="lazy"/>
            </div>
          </div>

          <div class="col-lg-8">
            <div class="row counters">
              <div class="col-md-4" data-aos="fade-up" data-aos-delay="300">
                <h2><span data-purecounter-start="0" data-purecounter-end="185" data-purecounter-duration="1" class="purecounter"></span>+</h2>
                <p>Companies</p>
              </div>

              <div class="col-md-4" data-aos="fade-up" data-aos-delay="400">
                <h2><span data-purecounter-start="0" data-purecounter-end="32" data-purecounter-duration="1" class="purecounter"></span>K</h2>
                <p>Students Hired</p>
              </div>

              <div class="col-md-4" data-aos="fade-up" data-aos-delay="500">
                <h2><span data-purecounter-start="0" data-purecounter-end="8" data-purecounter-duration="1" class="purecounter"></span>+</h2>
                <p>Serving States</p>
              </div>
            </div>
          </div>
        </div>
      {/* </div> */}

    </section>




{/* ===================================================================== Pricing ================================================================== */}
 <section id="pricing" class="pricing section">


      <div class="container section-title" data-aos="fade-up">
        <h2>Pricing</h2>
        <p>Flexible plans for teams of all sizes</p>
      </div>

      <div class="container" data-aos="fade-up" data-aos-delay="100">

        <div class="row gy-4">
         
          <div class="col-lg-4 col-md-6" data-aos="zoom-in" data-aos-delay="200">
            <div class="pricing-card">
              <div class="plan-header">
                <div class="plan-icon">
                  <i class="bi bi-box"></i>
                </div>
                <h3>Starter</h3>
                <p>Free</p>
              </div>
              <div class="plan-pricing">
                <div class="price">
                  <span class="currency">$</span>
                  <span class="amount">12</span>
                  <span class="period">/month</span>
                </div>
              </div>
              <div class="plan-features">
                <ul>
                  <li><i class="bi bi-check-circle-fill"></i> Basic applicant tracking</li>
                  <li><i class="bi bi-check-circle-fill"></i> Limited AI screening</li>
                  <li><i class="bi bi-check-circle-fill"></i> Standard reports</li>
                  <li class="disabled"><i class="bi bi-x-circle-fill"></i> Role Based Dashboards</li>
                  <li class="disabled"><i class="bi bi-x-circle-fill"></i> AI Resume Screening</li>
                </ul>
              </div>
              <div class="plan-cta">
                <a href="#" class="btn-plan">Choose Plan</a>
              </div>
            </div>
          </div>

      
          <div class="col-lg-4 col-md-6" data-aos="zoom-in" data-aos-delay="300">
            <div class="pricing-card popular">
              <div class="popular-tag">Most Popular</div>
              <div class="plan-header">
                <div class="plan-icon">
                  <i class="bi bi-briefcase"></i>
                </div>
                <h3>Professional</h3>
                <p>For small teams and growing businesses</p>
              </div>
              <div class="plan-pricing">
                <div class="price">
                  <span class="currency">$</span>
                  <span class="amount">39</span>
                  <span class="period">/month</span>
                </div>
              </div>
              <div class="plan-features">
                <ul>
                  <li><i class="bi bi-check-circle-fill"></i> Advanced AI ranking</li>
                  <li><i class="bi bi-check-circle-fill"></i> Automated scheduling</li>
                  <li><i class="bi bi-check-circle-fill"></i> Analytics dashboard</li>
                  <li><i class="bi bi-check-circle-fill"></i> Basic applicant tracking</li>
                  <li class="disabled"><i class="bi bi-x-circle-fill"></i> Standard reports</li>
                </ul>
              </div>
              <div class="plan-cta">
                <a href="#" class="btn-plan">Choose Plan</a>
              </div>
            </div>
          </div>

        
          <div class="col-lg-4 col-md-6" data-aos="zoom-in" data-aos-delay="400">
            <div class="pricing-card">
              <div class="plan-header">
                <div class="plan-icon">
                  <i class="bi bi-building"></i>
                </div>
                <h3>Enterprise</h3>
                <p>For large organizations and corporations</p>
              </div>
              <div class="plan-pricing">
                <div class="price">
                  <span class="currency">$</span>
                  <span class="amount">79</span>
                  <span class="period">/month</span>
                </div>
              </div>
              <div class="plan-features">
                <ul>
                  <li><i class="bi bi-check-circle-fill"></i> Custom AI models</li>
                  <li><i class="bi bi-check-circle-fill"></i> ATS integrations</li>
                  <li><i class="bi bi-check-circle-fill"></i> Dedicated support</li>
                  <li><i class="bi bi-check-circle-fill"></i> Automated scheduling</li>
                  <li><i class="bi bi-check-circle-fill"></i> Standard reports</li>
                </ul>
              </div>
              <div class="plan-cta">
                <a href="#" class="btn-plan">Choose Plan</a>
              </div>
            </div>
          </div>
        </div>

      </div>

    </section>


{/* ===================================================================== Contact ================================================================== */}

 <section id="contact" class="contact section">
      <div class="container section-title" data-aos="fade-up">
        <h2>Contact</h2>
        <p>Ready to transform your hiring process?</p>
      </div>

      <div class="container" data-aos="fade-up" data-aos-delay="100">
        <div class="row">
          <div class="col-lg-6 mb-5" data-aos="fade-right" data-aos-delay="200">
            <div class="contact-info-section">
              <div class="info-header">
                <h3>Connect With Us</h3>
                <p>Have Questions? Let's Talk</p>
              </div>

              <div class="contact-info-grid">
                <div class="info-item" data-aos="zoom-in" data-aos-delay="250">
                  <div class="info-icon">
                    <i class="bi bi-geo-alt-fill"></i>
                  </div>
                  <div class="info-content">
                    <h5>Visit Our Office</h5>
                    <p>1247 Fifth Avenue, Banglore, NY 10029</p>
                  </div>
                </div>

                <div class="info-item" data-aos="zoom-in" data-aos-delay="300">
                  <div class="info-icon">
                    <i class="bi bi-envelope-fill"></i>
                  </div>
                  <div class="info-content">
                    <h5>Send Email</h5>
                    <p>strategichire@snipetech.com</p>
                  </div>
                </div>

                <div class="info-item" data-aos="zoom-in" data-aos-delay="350">
                  <div class="info-icon">
                    <i class="bi bi-telephone-fill"></i>
                  </div>
                  <div class="info-content">
                    <h5>Call Direct</h5>
                    <p>+91 9935094590</p>
                  </div>
                </div>

                <div class="info-item" data-aos="zoom-in" data-aos-delay="400">
                  <div class="info-icon">
                    <i class="bi bi-clock-fill"></i>
                  </div>
                  <div class="info-content">
                    <h5>Business Hours</h5>
                    <p>Mon-Sat: 8AM - 7PM</p>
                  </div>
                </div>
              </div>

              <div class="social-contact" data-aos="fade-up" data-aos-delay="450">
                <h5>Follow Our Journey</h5>
                <div class="social-icons">
                  <a href="#" class="social-icon"><i class="bi bi-facebook"></i></a>
                  {/* <a href="#" class="social-icon"><i class="bi bi-x-lg"></i></a> */}
                  <a href="#" class="social-icon"><i class="bi bi-linkedin"></i></a>
                  <a href="#" class="social-icon"><i class="bi bi-youtube"></i></a>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6" data-aos="fade-left" data-aos-delay="200">
            <div class="contact-form-wrapper">
              <div class="form-header">
                <h3>Send Us Message</h3>
                <p>Feel free to connect...</p>
              </div>

              <form action="forms/contact.php" method="post" class="php-email-form">
                <div class="mb-3">
                  <label for="contactName" class="form-label">Full Name</label>
                  <input type="text" name="name" class="form-control" id="contactName" placeholder="Enter your full name" required=""/>
                </div>

                <div class="mb-3">
                  <label for="contactEmail" class="form-label">Email Address</label>
                  <input type="email" class="form-control" name="email" id="contactEmail" placeholder="Enter your email address" required=""/>
                </div>

                <div class="mb-3">
                  <label for="contactPhone" class="form-label">Phone Number</label>
                  <input type="tel" class="form-control" name="phone" id="contactPhone" placeholder="Enter your phone number"/>
                </div>

                <div class="mb-3">
                  <label for="contactSubject" class="form-label">Subject</label>
                  <input type="text" class="form-control" name="subject" id="contactSubject" placeholder="Enter message subject" required=""/>
                </div>

                <div class="mb-4">
                  <label for="contactMessage" class="form-label">Your Message</label>
                  <textarea class="form-control message-textarea" name="message" id="contactMessage" rows="5" placeholder="Enter your message" required=""></textarea>
                </div>

                <div class="my-3">
                  <div class="loading">Loading</div>
                  <div class="error-message"></div>
                  <div class="sent-message">Your message has been sent. Thank you!</div>
                </div>

                <button type="submit" class="submit-btn">
                  <span>Send Message</span>
                  <i class="bi bi-arrow-right"></i>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>




      </main>
    </>
  );
}
